<ngx-spinner bdOpacity=0.5 bdColor="rgba(0,0,0,0.84)" size="default" color="#fff" type="ball-pulse" [fullScreen]="true">
</ngx-spinner>
<ng-container *ngIf="objectKeys(episodeDetail).length > 0">
    <!-- <div class="row banner-dashboard-header">
        <div class="col-md-12">
            <div class="list_banner">
                <div class="row list-banner-inner">
                    <div class="col-md-3 img-box">
                        <img alt="{{episodeDetail?.title}}" src="{{episodeDetail?.image}}">
                    </div>
                    <div class="col-md-9">
                        <div class="list_b_con">
                            <span>{{episodeDetail?.podcast_name}}</span>
                            <h2>{{episodeDetail?.title}}</h2>
                            <p></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row episodes-list row-episode">
        <div class="col-md-10">

            <div class="el-footer">
                <div class="play_link"><a (click)="playAudio(episodeDetail)"><i class="fa fa-play-circle"
                            aria-hidden="true"></i></a>
                    <div class="time">{{secondsToDhms(episodeDetail?.audio_length_sec)}}</div>
                </div>
                <div class="episode-created">{{episodeDetail?.published_date | date:'MMM dd, y'}}</div>
            </div>
            <hr>
            <div class="el-content">
                <h4>About this episode</h4>
                <div [innerHtml]="episodeDetail?.description | podcastSanitizeHtml">
                </div>
              
            </div>
       
        </div>
    </div> -->
    <div class="col-12 site-banner pl-0 pr-0">
        <!---------------Single Banner------------------>
        <div class="single-pageBanner">
            <div class="single-image-Banner">
                <img alt="{{episodeDetail?.title}}" src="{{episodeDetail?.image}}">
            </div>
        </div>
        <!---------------END Single Banner------------------>
    </div>
    <div class="col-12 articlePodcasts-section px-100">
        <div class="row">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h3>{{episodeDetail?.title}}</h3>
                        <ul class="post-info">
                            <li><div class="date">{{episodeDetail?.published_date | date:'MMMM dd, y'}}</div></li>
                            <li><div><b>{{episodeDetail?.podcast_name}} - </b>{{secondsToDhms(episodeDetail?.audio_length_sec)}} read</div></li>
                        </ul>
                        <div [innerHtml]="episodeDetail?.description | podcastSanitizeHtml">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 newsPodcasts-section green-bg px-100">
        <div class="row">
            <div class="container">
                <div class="row">
                    <div class="col-12 text-center green-headtitle">
                        <h2>Latest <span>News</span></h2>
                    </div>
                    <div class="col-12 newsList">
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-4 news-item" *ngFor="let news of podcastArticles">
                                <div class="news-inner">
                                    <div class="thumb-image">
                                        <img [src]="news?.field_image_url_value" alt="{{news?.title}}">
                                    </div>
                                    <div class="thumb-content">
                                        <span class="date">{{news?.created | date:'MMMM dd, y'}}</span>
                                        <h4>{{news?.title}}</h4>
                                        <div [innerHtml]="news?.description | podcastSanitizeHtml">
                                            
                                        </div>
                                        <p><a href="{{news?.full_url}}" target="_blank">Read More</a></p>
                                        <!-- <p>Hayti (pronounced "HAY-tie") is the name of the historic African-American community that is now part of the city of Durham, NC. African-Americans named the community <a href="javascript:void(0);">Read More</a></p> -->
                                    </div>
                                </div>
                            </div>
                        
                        </div>
                        <div class="row">
                            <div class="col-12 mt-4 text-center">
                                <a  routerLink="/podcasts-web/news" class="btn btn-green">View More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>


<div *ngIf="objectKeys(episodeDetail).length == 0" class="cover-space">
</div>